/**
 * @deprecated
 * @param url
 */
export const getMediaUrl = (url = ''): string => {
  return url
}
